// extracted by mini-css-extract-plugin
export var modal = "_5h-0";